import { AsyncState, GiveawayType } from "@/store/types"
import { GameSlug } from "./enums"

type EventKey = string | number | symbol

type Handler<T = any> = (payload: T) => void

export type AppEvents = {
  "chat-user:blocked": string
  "chat-user:unblocked": string
  "giveaway:updated": AsyncState<GiveawayType<GameSlug>[]>
  //   "user:login": { id: number; name: string };
  //   "user:logout": void;
  //   "modal:open": string;
  //   "modal:close": void;
}

export class EventBus<Events extends Record<EventKey, any>> {
  private listeners: {
    [K in keyof Events]?: Set<Handler<Events[K]>>
  } = {}

  on<K extends keyof Events>(event: K, handler: Handler<Events[K]>) {
    if (!this.listeners[event]) {
      this.listeners[event] = new Set()
    }

    this.listeners[event]!.add(handler)
  }

  off<K extends keyof Events>(event: K, handler: Handler<Events[K]>) {
    this.listeners[event]?.delete(handler)
  }

  emit<K extends keyof Events>(
    event: K,
    ...args: Events[K] extends void ? [] : [payload: Events[K]]
  ) {
    this.listeners[event]?.forEach((handler) => {
      // @ts-expect-error safe due to conditional typing
      handler(...args)
    })
  }

  clear<K extends keyof Events>(event?: K) {
    if (event) {
      this.listeners[event]?.clear()
    } else {
      ;(Object.keys(this.listeners) as K[]).forEach((key) => {
        this.listeners[key]?.clear()
      })
    }
  }
}
